import { styled } from '@linaria/react';
import { themeCssVariables } from 'app-ui/theme';

import { getHotkeyHintKeys } from '@/ui/utilities/hotkey/utils/getHotkeyHintKeys';

const StyledHotkeyHint = styled.span`
  align-items: center;
  display: inline-flex;
  flex: none;
  gap: ${themeCssVariables.spacing[0.5]};
`;

const StyledKey = styled.kbd`
  align-items: center;
  background: ${themeCssVariables.background.transparent.lighter};
  border: 1px solid ${themeCssVariables.border.color.medium};
  border-radius: ${themeCssVariables.border.radius.sm};
  box-sizing: border-box;
  color: ${themeCssVariables.font.color.tertiary};
  display: inline-flex;
  font-family: ${themeCssVariables.font.family};
  font-size: ${themeCssVariables.font.size.xs};
  font-weight: ${themeCssVariables.font.weight.medium};
  height: ${themeCssVariables.spacing[4]};
  justify-content: center;
  line-height: 1;
  min-width: ${themeCssVariables.spacing[4]};
  padding: 0 ${themeCssVariables.spacing[1]};
`;

type HotkeyHintProps = {
  // Same format as useGlobalHotkeys: 'mod+k' or a sequence such as 'g h'.
  hotkey: string;
};

// Decorative: the action it belongs to already has an accessible name.
export const HotkeyHint = ({ hotkey }: HotkeyHintProps) => (
  <StyledHotkeyHint aria-hidden>
    {getHotkeyHintKeys(hotkey).map((key, keyIndex) => (
      <StyledKey key={`${key}-${keyIndex}`}>{key}</StyledKey>
    ))}
  </StyledHotkeyHint>
);
